import React from 'react'
import { BsInstagram, BsGithub, BsYoutube, BsLinkedin } from 'react-icons/bs'
import './socials.scss'

const Socials = () => {
  return (
    <div className="app__social"> 
        <div className="social__icon-gh">
        <a 
            href="https://github.com/Jubiko31" 
            target="_blank" 
            rel="noreferrer"
            
        >
            <BsGithub />
        </a>    
        </div>
        <div className="social__icon-li">
        <a 
            href="https://www.linkedin.com/in/jubiko-matsaberidze-7b66a7204/" 
            target="_blank" 
            rel="noreferrer"
        >
            <BsLinkedin />
        </a>  
            
        </div>
        <div className="social__icon-ig">
        <a  
            href="https://www.instagram.com/j_matsaberidze/" 
            target="_blank" 
            rel="noreferrer"
        >
            <BsInstagram />
        </a>  
            
        </div>
        <div className="social__icon-yt">
        <a 
            href="https://www.youtube.com/channel/UCKCChLap5WQzTOfEO5OzRuA"  
            target="_blank" 
            rel="noreferrer"
        >
            <BsYoutube />
        </a>  
        </div>
    </div>
  )
}

export default Socials